import { DateInput } from '@mantine/dates';
import { ReactNode } from 'react';
import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';

import { RO_DATE_FORMAT } from '@feature/utils';

import classes from './Input.module.css';

export interface DateInputControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string;
  placeholder?: string;
  minDate?: string;

  isDisabled?: boolean;

  leftSection?: ReactNode;
  leftSectionWidth?: string;
}

export function DateInputControl<T extends FieldValues>(props: DateInputControlProps<T>) {
  const {
    withAsterisk,
    label,
    placeholder,
    description,
    minDate,
    name,
    isSubmitting,
    isDisabled,
    leftSection,
    leftSectionWidth,
  } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name });

  return (
    <DateInput
      className={classes.datePicker}
      ref={field.ref}
      name={field.name}
      value={field.value}
      valueFormat={RO_DATE_FORMAT}
      minDate={minDate}
      onChange={field.onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      withAsterisk={withAsterisk}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      flex={1}
      leftSection={leftSection}
      leftSectionWidth={leftSectionWidth}
    />
  );
}
